/* eslint-disable import/prefer-default-export */
export function AddressSummary(props) {
  const { address, states } = props;
  if (!address) return null;
  return (
    <div className="multi-address">
      <div className="shipping-full-address address-summary ">
        {address?.label && (
          <div id="address-detail-label" className="address-detail-left">
            <label htmlFor="address-detail-label">#{address.label}</label>
          </div>
        )}
        <h2 key={address.id}>
          {address.address1}, {address?.address2 ? address?.address2 : ""}{" "}
          {address.city},{" "}
          {states.find((state) => state.value === address.provinceCode)?.label},{" "}
          {address.zip}, {address.country}
        </h2>
      </div>
    </div>
  );
}
